module.exports = __webpack_public_path__ + "img/top-image-finish.1a97f08f.png";